import { BaseDynamicFormElement } from '../model';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import { RequiredIfValidator } from '@ebeihilfe/core';

@Injectable()
export class DynamicFormControlService {
  public toFormGroup(elements: BaseDynamicFormElement<string>[], form: FormGroup): void {
    for (const element of elements) {
      const options: ValidatorFn[] = [];

      if (element.required) {
        options.push(Validators.required);
      } else if (element.requiredIf != null) {
        options.push(RequiredIfValidator(element.requiredIf));
      }

      if (element.requiredTrue) {
        options.push(Validators.requiredTrue);
      }

      if (element.errors?.length > 0) {
        this.addFormValidation(element, options);
      }

      form.addControl(element.key, new FormControl(element.value ?? '', options));
    }
  }

  public addFormValidation(element: BaseDynamicFormElement<string>, options: ValidatorFn[]): void {
    for (const error of element.errors) {
      switch (error.errorCode) {
        case 'min':
          options.push(Validators.min(Number(element.min)));
          break;
        case 'max':
          options.push(Validators.max(Number(element.max)));
          break;
      }
    }
  }
}
